import { render } from "./GeneralLedgerReport.vue?vue&type=template&id=a4dcc056&scoped=true"
import script from "./GeneralLedgerReport.vue?vue&type=script&lang=js"
export * from "./GeneralLedgerReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=a4dcc056&scoped=true&lang=css&external"
import "./accountingReport.css?vue&type=style&index=1&id=a4dcc056&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4dcc056"]])

export default __exports__